import Cookies from 'universal-cookie';
const cookies = new Cookies();
export const cutValue = (val) => {
    let formatVal = val;
    if (val > 10000) {
        formatVal = val / 10000;
        formatVal = formatVal % 1 !== 0 ? formatVal.toFixed(2) : formatVal;
        formatVal = `${formatVal}K`;
    }
    if (val > 100000) {
        formatVal = val / 1000000;
        formatVal = formatVal % 1 !== 0 ? formatVal.toFixed(2) : formatVal;
        formatVal = `${formatVal}M`;
    }
    return formatVal;
};
export function roundHundred(value) {
    return Math.round(value / 100) * 100;
}
export function roundThousand(value) {
    return Math.round(value / 1000) * 1000;
}
export function roundFiveThousand(value) {
    return Math.round(value / 5000) * 5000;
}
export function roundFifty(value) {
    return Math.round(value / 50) * 50;
}
export const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
export const clearUrl = (string) => string.replace(/\/\//g, '/');
export const arrayMonth = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const isTablet = () => {
    if (typeof window !== 'undefined') {
        if (window.innerWidth > 1024) {
            return false;
        }
        return true;
    }
    return false;
};
export const isMobile = () => {
    if (typeof window !== 'undefined') {
        if (window.innerWidth > 768) {
            return false;
        }
        return true;
    }
    return false;
};
const maxPrice = 5000000;
export const maxPriceRatio = maxPrice / 100;
const maxPriceM2 = 15000;
export const maxPriceM2Ratio = maxPriceM2 / 100;
const maxLivingSpace = 300;
export const maxLivingSpaceRatio = maxLivingSpace / 100;
export const getNumElArray = (arr) => {
    let num = 0;
    arr.map((item) => {
        if (Object.keys(item).length > num) {
            num = Object.keys(item).length;
        }
        return null;
    });
    return num;
};
export const getQueryVariableUrl = (url, variable, action = 'normal') => {
    let query;
    if (action === 'full') {
        query = url.split('?');
        if (query[1])
            query = query[1];
        else
            query = query[0];
    }
    else {
        query = url.replace('?', '');
    }
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i += 1) {
        const pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return variable;
};
export const sortObjByKey = (obj, key, isBool = false) => {
    let orderedObj = obj;
    if (isBool) {
        orderedObj = obj.sort((a, b) => b[key] - a[key]);
    }
    return orderedObj;
};
export const setCookie = (key, val) => {
    const host = window.location.host.split('.');
    // var localhost = host[0].match(/localhost/gi);
    const localip = host[0];
    let domain;
    if (localip.includes('localhost')) {
        domain = 'localhost';
    }
    else if (typeof localip === 'number') {
        domain = '0.0.0.0';
    }
    else {
        const curDomain = document.location.hostname.split('.')[document.location.hostname.split('.').length - 1];
        domain = `.brixel.${curDomain}`;
    }
    const options = {
        domain,
        path: '/',
        expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
    };
    cookies.set(key, val, options);
};
export const getCookie = (key) => {
    return cookies.get(key);
};
export const unsetCookie = (key) => {
    const host = window.location.host.split('.');
    // var localhost = host[0].match(/localhost/gi);
    const localip = host[0];
    let domain;
    if (localip.includes('localhost')) {
        domain = 'localhost';
    }
    else if (typeof localip === 'number') {
        domain = '0.0.0.0';
    }
    else {
        const curDomain = document.location.hostname.split('.')[document.location.hostname.split('.').length - 1];
        domain = `.brixel.${curDomain}`;
    }
    const options = {
        domain,
        path: '/',
    };
    cookies.remove(key, options);
};
